import React, { HTMLAttributes } from 'react';

type IProps = HTMLAttributes<HTMLSpanElement>;

export default function Loader(props: IProps) {
  return (
    <span {...props}>
      <i className="fa-solid fa-spinner fa-spin-pulse fa-spin-reverse fa-2x" />
    </span>
  );
}
